module.exports = __webpack_public_path__ + "img/goods_coupon_chiba03_used.5beac7fd.png";